var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftLineArrow = function SvgLeftLineArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.375 11.875c0 .414.336.75.75.75h10.44l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4 .026-.027a.8.8 0 0 0 .137-.216l.001-.002a.75.75 0 0 0-.164-.815l-4-4a.75.75 0 1 0-1.06 1.06l2.72 2.72H6.124a.75.75 0 0 0-.75.75",
    clipRule: "evenodd"
  })));
};
export default SvgLeftLineArrow;